import { IconButton } from "@assetwatch/ui";

type GuidedChatComposerProps = {
  disabled: boolean;
  onChange: (value: string) => void;
  onSend: () => void;
  value: string;
};

export function GuidedChatComposer({
  disabled,
  onChange,
  onSend,
  value,
}: GuidedChatComposerProps) {
  const sendDisabled = disabled || value.trim().length === 0;

  return (
    <div className="flex w-full items-center gap-(--spacing-10)">
      <div className="flex h-(--spacing-40) min-w-0 flex-1 items-center rounded-full border border-input-default-outline bg-input-default-background px-(--spacing-16) transition-colors focus-within:border-input-active-outline">
        <input
          aria-label="Describe the work request"
          className="min-w-0 flex-1 bg-transparent font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default outline-none placeholder:text-input-text-placeholder"
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") onSend();
            if (event.key === "Escape") event.currentTarget.blur();
          }}
          placeholder="Reply..."
          value={value}
        />
      </div>
      <IconButton
        aria-label="Send"
        disabled={sendDisabled}
        icon="arrow-right"
        onClick={onSend}
        size="md"
      />
    </div>
  );
}
